import { render } from "./GlobalPermissions.vue?vue&type=template&id=58de0335&scoped=true"
import script from "./GlobalPermissions.vue?vue&type=script&lang=js"
export * from "./GlobalPermissions.vue?vue&type=script&lang=js"

import "./GlobalPermissions.vue?vue&type=style&index=0&id=58de0335&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58de0335"]])

export default __exports__